import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIEsl',
    label: 'SSBIEsl',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
